export const ADD_VARIANT = 'ADD_VARIANT';
